module.exports = __webpack_public_path__ + "media/enter_restaurant.a275f9de.mp3";